export const HOT_CITY = 'HOT_CITY';
export const CONFIG_HOT_CITY = 'gdsHotArea';
